import { CButton } from "@coreui/react";
import { FC, ReactEventHandler } from "react";
import { useIsMutating } from "react-query";
import LoadingButton from "./LoadingButton";

type SubmitButtonProps = {
  color?: string;
  size?: string;
  text: string;
  className?: string;
  onSubmit: ReactEventHandler<HTMLButtonElement>;
  disabled?: boolean;
};

const SubmitButton: FC<SubmitButtonProps> = ({
  size,
  color,
  text,
  className,
  onSubmit,
  disabled,
}) => {
  const isMutating = useIsMutating();

  return isMutating ? (
    <LoadingButton size={size} color={color} />
  ) : (
    <CButton
      color={color ?? "primary"}
      size={size ?? ""}
      onClick={onSubmit}
      className={className}
      type="submit"
      disabled={disabled}
    >
      {text}
    </CButton>
  );
};

export default SubmitButton;
